/*
  Переход «вход → рабочее место» (docs/brand-concept.md §5). Страница входа запоминает, где на
  экране стоял знак; оболочка при старте берёт эту точку и разыгрывает переход: веер складывается,
  ядро летит в свой дом в главном меню, рабочее место собирается. Вход через Google уводит со
  страницы, поэтому точка живёт в sessionStorage, а не в памяти.
*/

export interface EntranceFrom {
  /** Центр знака на экране, px. */
  x: number;
  y: number;
  /** Сторона знака, px. */
  size: number;
  /** Лепестки на момент входа: сплошные или окна «глубины». */
  variant: 'solid' | 'window';
}

const KEY = 'kaname.entrance';

export function saveEntrance(from: EntranceFrom) {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(from));
  } catch {
    // Хранилище недоступно — оболочка просто откроется без перехода.
  }
}

/** Прочитать точку входа, не стирая: в строгом режиме разработки инициализатор вызывается дважды. */
export function peekEntrance(): EntranceFrom | null {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as EntranceFrom;
    return typeof v.x === 'number' && typeof v.size === 'number' ? v : null;
  } catch {
    return null;
  }
}

export function clearEntrance() {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // нечего стирать
  }
}

export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
